// extracted by mini-css-extract-plugin
export default {"socialMedia":"Footer_socialMedia__7j2ct","socialIcons":"Footer_socialIcons__sGCdc","Footer":"Footer_Footer__QXo5o","FooterList":"Footer_FooterList__UWxzz"};